var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('div', {
    ref: "slider",
    class: _vm.classObj,
    style: (_vm.styleObj)
  }, [_c('n3-tooltip', {
    attrs: {
      "placement": _vm.orientation === 'horizontal' ? 'top' : 'right',
      "noresize": true,
      "trigger": "mouse"
    }
  }, [_c('div', {
    class: (_vm.prefixCls + "-slider-track")
  }, [_c('div', {
    class: (_vm.prefixCls + "-slider-track-low")
  }), _vm._v(" "), _c('div', {
    ref: "selection",
    class: (_vm.prefixCls + "-slider-selection")
  }), _vm._v(" "), _c('div', {
    ref: "noSelection",
    class: (_vm.prefixCls + "-slider-track-high")
  }), _vm._v(" "), _c('div', {
    ref: "minSlider",
    class: (_vm.prefixCls + "-slider-handle " + _vm.prefixCls + "-slider-min-slider-handle " + _vm.prefixCls + "-slider-round")
  }), _vm._v(" "), _c('div', {
    ref: "maxSlider",
    class: (_vm.prefixCls + "-slider-handle " + _vm.prefixCls + "-slider-max-slider-handle " + _vm.prefixCls + "-slider-round")
  })])])], 1), _vm._v(" "), _c('validate', {
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules,
      "custom-validate": _vm.customValidate,
      "current": _vm.value
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7ac03a0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac03a0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Slider/n3Slider.vue
// module id = 643
// module chunks = 0 1